import React, { useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { signInWithGoogle, auth } from "../firebase";

import { ColorModeContext } from "../context/ColorModeProvider";

import { toast } from "react-toastify"; // then this

import {
  CssBaseline,
  Container,
  Box,
  Grid,
  Card,
  Typography,
  Button,
  TextField,
  Stack,
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";

import styled from "@emotion/styled";

const StyledBox = styled(Box)``;

const SignIn = () => {
  const { theme } = useContext(ColorModeContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (email && password) {
      try {
        const { user } = await auth.signInWithEmailAndPassword(email, password);

        // Alert.success("Successfully Signed In", 2000);
        toast.success("Welcome back!", {
          theme: "colored",
        });
        history.push("/");
      } catch (error) {
        // Alert.error(error.message, 3000);
        toast.error(`${error.message}`, {
          theme: "colored",
        });
      }
    } else {
      // Alert.error("Fields are empty", 3000);
      toast.error("Fields are empty", {
        theme: "colored",
      });
    }
  };
  return (
    <Card
      // sx={{ pl: 3, pr: 3, pt: 3, pb: 3 }}
      sx={{
        padding: {
          xs: "1.6em",
          sm: "2em",
          md: "2em",
          lg: "2em",
        },
      }}
    >
      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField
            value={email}
            label="Email"
            // onChange={(e) => setEmail(e)}
            onChange={(e) => setEmail(e.target.value)}
            name="name"
          />
          <TextField
            name="password"
            value={password}
            label="Password"
            // onChange={(e) => setPassword(e)}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
          />
        </Stack>
        <Stack
          direction="row"
          mt={2}
          spacing={2}
          justifyContent="space-between"
        >
          <Typography sx={{ pt: 0.5, pb: 0.5, pl: 1 }} fontSize="small">
            <Link
              style={{
                color: theme.palette.mode === "dark" ? "#00bfc6" : "#00bfc6",
                textDecoration: "none",
              }}
              to="/forgot-password"
              className="forgot__password"
            >
              Forgot Password?
            </Link>
          </Typography>
          <Typography sx={{ pt: 0.5, pb: 0.5, pr: 1 }} fontSize="small">
            <Link
              style={{
                color: theme.palette.mode === "dark" ? "#00bfc6" : "#00bfc6",
                textDecoration: "none",
              }}
              to="/signup"
            >
              Register
            </Link>
          </Typography>
        </Stack>
        <Stack direction="row" mt={2} spacing={2}>
          <Button
            variant="contained"
            type="submit"
            // size="small"
            sx={{
              lineHeight: {
                xs: "1.8em",
                sm: "3em",
                md: "3em",
                lg: "3em",
              },
            }}
          >
            Login
          </Button>

          <Button
            // size="small"
            sx={{
              lineHeight: {
                xs: "1.8em",
                sm: "3em",
                md: "3em",
                lg: "3em",
              },
            }}
            variant="contained"
            onClick={signInWithGoogle}
            startIcon={<GoogleIcon />}
          >
            Login with Google
          </Button>
        </Stack>
      </form>
    </Card>
  );
};

export default SignIn;
